import { RouteConfig } from 'vue-router';

import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentDecisionRoute: RouteConfig = {
  path: 'decision',
  name: 'documentDecision',
  component: () => import(/* webpackChunkName: "DocumentDecision" */ '@/views/mainRoute/document/details/Decision.vue'),
  meta: { breadcrumb: { title: 'Dane decyzji' } },
  beforeEnter: (to, from, next) => {
    const documentId = tryParseInt(to.params.documentId);
    store.commit('documentIndex/setId', documentId);
    Promise.all([
      store.dispatch('documentIndex/get'),
      store.dispatch('documentValue/find', { documentId, code: DocumentValueCodes.DECISIONS }),
      store.dispatch('setting/findPublic', {
        code: PublicSettings.DECISION_DATA_DATES_DICTIONARY
      })
    ]).then(() => next());
  }
};
